var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C17.5228 2 22 6.47716 22 12C22 17.5228 17.5228 22 12 22C6.47716 22 2 17.5228 2 12C2 6.47716 6.47716 2 12 2Z",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0506 12.4673C14.3216 13.2533 12.3376 14.5833 11.3226 15.0103C11.1606 15.0783 10.7476 15.2223 10.6586 15.2243C10.4696 15.2303 10.2876 15.1243 10.1996 14.9543C10.1656 14.8883 10.0656 14.4573 10.0336 14.2653C9.93864 13.6813 9.88964 12.7743 9.89064 11.8623C9.88964 10.9053 9.94264 9.95532 10.0486 9.37732C10.0766 9.22132 10.1586 8.86232 10.1826 8.80432C10.2276 8.69632 10.3096 8.61132 10.4086 8.55832C10.4846 8.51732 10.5716 8.49532 10.6586 8.49832C10.7476 8.50032 11.1096 8.62732 11.2336 8.67632C12.2116 9.05632 14.2806 10.4343 15.0406 11.2443C15.1086 11.3173 15.2956 11.5133 15.3266 11.5533C15.3976 11.6433 15.4326 11.7523 15.4326 11.8623C15.4326 11.9643 15.4016 12.0683 15.3376 12.1553C15.3046 12.2003 15.1136 12.4003 15.0506 12.4673Z",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedPlay);
export default __webpack_public_path__ + "static/media/roundedPlay.754acc68ec9a80575bc9130ab702d6d2.svg";
export { ForwardRef as ReactComponent };